import React from "react";

function Footer() {
  return (
    <div className="footer fixed-bottom text-center p-2 bg-dark text-white">
      &copy;Made with <i className="bi bi-heart-fill"></i> by Ashutosh Mishra
    </div>
  );
}

export default Footer;
